import axios from 'axios';
import { fromJS } from 'immutable';
import { appDb, dispatch, pathSubscription, subscription } from 'nike-re-framejs';
import { isImplicitReason } from './views/reason';

const context = {
    reason: null,
    jwt: null,
    methods: [],
    callback: function() {}
};

// toto by asi bolo lepsie prehodit do reframu :(
export function set2FAContext(jwt, methods, reason, payload, callback) {
    context.jwt = jwt;
    context.methods = methods;
    context.reason = reason;
    context.payload = payload;
    context.callback = callback;
}

export function get2FAContext() {
    return context;
}

export function getAvailableMethods() {
    return context.methods;
}

export function runContextCallback(token) {
    return context
        .callback(token)
        .catch(error => {
            console.log('error while 2FA login:', error);
            return Promise.reject(error);
        })
        .then(() => token);
}

export function createPayload(changeEntries) {
    const values = changeEntries.reduce(
        (ret, entry) => {
            ret.current.push(entry.currentValue);
            ret.new.push(entry.newValue);
            return ret;
        },
        { current: [], new: [] }
    );
    return { oldValue: values.current.join('|'), newValue: values.new.join('|') };
}

export function call2FAMethod(method) {
    const { jwt, reason, payload } = context;
    return axios
        .post('/api/2fa/methods/use', { jwt, method, reason, payload })
        .then(response => dispatch(set2FATransaction(response, method)));
}

export function verify2FACode(userCode) {
    const id2fa = appDb.peekValue().getIn(['2FA', 'id']);
    return axios
        .post('/api/2fa/codes/verify', {
            id2fa,
            userCode
        })
        .then(response => response.token2FA)
        .then(token => {
            // zmena sa vykona automaticky, ak je reason implicitny (vsetky okrem loginu)
            if (isImplicitReason(context.reason)) {
                return runContextCallback(token);
            } else {
                return token;
            }
        })
        .then(token => dispatch(set2FAToken(token)));
}

function set2FATransaction(transaction, method) {
    return db => db.setIn(['2FA'], fromJS(transaction)).setIn(['2FA', 'method'], method);
}

export function set2FAError(error) {
    return db => db.setIn(['2FA', 'error'], error);
}

function set2FAToken(token) {
    return db => db.setIn(['2FA', 'token'], token);
}

export function restart2FA() {
    return db => db.deleteIn(['2FA']);
}

export const tx2FA$ = pathSubscription(['2FA']);

export const isPortalLogged$ = pathSubscription(['account', 'user', 'contractNumber']);
const isMobileLoged$ = pathSubscription(['account', 'userData', 'cisloZmluvy']);
export const isLogged$ = subscription((l1, l2) => l1 || l2, isPortalLogged$, isMobileLoged$);
